import reducer from './reducers'
import { loginAuth, logoutAuth } from './actions'

const actions = {
    loginAuth,
    logoutAuth,
}

export default { actions, reducer }
